import { uniqueId } from '../../store/utils.js';

/**
 * Элемет, значение
 */
export default class WapiSynopElement {
  constructor(name) {
    this.name = name;
    this.val = 0.0;
    this.avg = 0.0;
    this.min = 0.0;
    this.max = 0.0;
    this.period = 0.0;
    this.height = 0.0;
    this.units = '';
  }
}

export function toWapiSynopElement(data) {
  const exclude = ['index', 'obs_time', 'id', 'items'];
  data.forEach(x => {
    x['id'] = uniqueId('synop_');
    x['items'] = [];
    const props = Object.entries(x);
    for (const p of props) {
      if (exclude.includes(p[0])) continue;
      const synopElement = new WapiSynopElement(p[0]);
      synopElement.val = x[p[0]].val;
      synopElement.avg = x[p[0]].avg;
      synopElement.min = x[p[0]].min;
      synopElement.max = x[p[0]].max;
      synopElement.period = x[p[0]].period;
      synopElement.height = x[p[0]].height;
      synopElement.units = x[p[0]].units;
      x.items.push(synopElement);
    }
  });
}